import { useRef } from "react";
import { motion, useInView, animate } from "framer-motion";
import { useState, useEffect } from "react";

export const PRICE = 39.99;
export const COMPARE_PRICE = 69.99;
export const SHIPPING_FEE = 4.99;

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -72, duration: 1.6 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pt-[0.14em] pb-[0.06em] ${className}`}>
    <motion.span
      className="block -mt-[0.14em] will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Counter = ({ to, suffix = "", className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2.2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} className={className}>
      {val.toLocaleString("en-US")}
      {suffix}
    </span>
  );
};

export const SectionTag = ({ index, label }) => (
  <div className="flex items-center gap-3 font-mono text-xs tracking-[0.3em] uppercase text-smoke">
    <span className="text-volt">{index}</span>
    <span className="h-px w-10 bg-steel" aria-hidden="true" />
    <span>{label}</span>
  </div>
);

const trackClick = (source) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/checkout-click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source }),
      keepalive: true,
    });
  } catch {
    // analytics must never block checkout
  }
};

export const goCheckout = (bundle) => {
  trackClick(`bundle-${bundle}`);
  window.location.assign(`/checkout?bundle=${bundle}`);
};

export const buyNow = () => goCheckout("solo");

const BUNDLE_KEYS = { 1: "solo", 2: "duo", 3: "squad" };
export const buyBundle = (units) => goCheckout(BUNDLE_KEYS[units] || "solo");

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
